var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11438 12.7141L8 14.5997M8 14.5997L9.88562 12.7141M8 14.5997V10.8285M9.88562 3.28601L8 1.40039M8 1.40039L6.11438 3.28601M8 1.40039V5.17163M12.714 6.11444L14.5997 8.00005M14.5997 8.00005L12.714 9.88567M14.5997 8.00005H10.8284M3.28596 9.88567L1.40034 8.00005M1.40034 8.00005L3.28596 6.11444M1.40034 8.00005H5.17157",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_2031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.4e1a970260a7b634b6c5faeab2443d5d.svg";
export { ForwardRef as ReactComponent };